import { render, staticRenderFns } from "./SetupAutomationModal.vue?vue&type=template&id=9f50235a&scoped=true&"
import script from "./SetupAutomationModal.vue?vue&type=script&lang=js&"
export * from "./SetupAutomationModal.vue?vue&type=script&lang=js&"
import style0 from "./SetupAutomationModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SetupAutomationModal.vue?vue&type=style&index=1&id=9f50235a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f50235a",
  null
  
)

export default component.exports